import React, { FC } from 'react';
import { StyledTextWrapper } from './styled';

const CommunityGuidelinesText: FC = () => <StyledTextWrapper />;

export default CommunityGuidelinesText;
